import { FC, ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './EspStatCard.module.scss'

interface IEspStatCardProps {
  titleKey: string
  value: ReactNode
}

export const EspStatCard: FC<IEspStatCardProps> = ({ titleKey, value }) => (
  <div className={styles.root}>
    <div className={styles.title}>
      <Translation text={titleKey} span />
    </div>
    <div className={styles.value}>{value}</div>
  </div>
)

EspStatCard.displayName = 'EspStatCard'
